/// <reference path="../../TypeLite.Net4.d.ts" />
import * as React from 'react'
import * as ReactDom from 'react-dom'
import { Link } from 'react-router-dom';
import { SkodaTooltip } from '../skodaTooltip';
import { ResourceProvider } from '../../resourceProvider';

export interface IServiceProps {
	service: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ServiceModel,
	appliedFilter: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Filters.DataFilter,
	orderInGroup: number,
	showAvailability: boolean,
	onClick?: (code: string, originTitle: string) => void
}

export interface IServiceState {

}

export class ServiceItem extends React.Component<IServiceProps, IServiceState>
{
	constructor(props: IServiceProps) {
		super(props);

		this.onClickItem = this.onClickItem.bind(this);
		this.getTooltipContent = this.getTooltipContent.bind(this);
	}

	private onClickItem(e: any): void {
		if (this.props.onClick) {
			this.props.onClick(this.props.service.Code, this.props.service.OriginTitle);
		}
	}

	private getTooltipContent(parentKey: string): JSX.Element {
		let message: JSX.Element[] = [];

		if (this.props.service.AvailableForProductions && this.props.service.AvailableForProductions.length > 0) {
			message.push(<span key={this.props.service.Id.toString() + parentKey + '_textTooltip'}>{ResourceProvider.getText('Tooltip.ServiceAvailability')}</span>);

			for (var i = 0; i < this.props.service.AvailableForProductions.length; i++) {
				if (this.props.service.AvailableForProductions[i].From) {
					message.push(<span key={this.props.service.Id.toString() + parentKey + '_resourceFrom_' + i}> { ' ' + ResourceProvider.getText('Tooltip.MadeFromPeriod') + ' ' }</span >);
					message.push(<strong key={this.props.service.Id.toString() + parentKey + '_periodFrom_' + i}>{this.props.service.AvailableForProductions[i].From.Title}</strong>);
				}
				if (this.props.service.AvailableForProductions[i].To) {
					message.push(<span key={this.props.service.Id.toString() + parentKey + '_resourceTo_' + i}>{' ' + ResourceProvider.getText('Tooltip.MadeToPeriod') + ' '}</span>);
					message.push(<strong key={this.props.service.Id.toString() + parentKey + '_periodTo_' + i}>{this.props.service.AvailableForProductions[i].To.Title}</strong>);
				}
				if (i < (this.props.service.AvailableForProductions.length - 1)) {
					message.push(<span key={this.props.service.Id.toString() + parentKey + '_periodSeparator_' + i}>{ResourceProvider.getText('Tooltip.PeriodSeparator') + ' '}</span>);
				}
			}

			return (
				<div>{message}</div>
			);
		}

		return null;
	}

	public render(): JSX.Element {
		let service = this.props.service;
		let showWarning = this.props.appliedFilter && this.props.appliedFilter.InfotainmentCode && this.props.appliedFilter.FamilyCode && !this.props.appliedFilter.ProductionFromCode && service.IsAvailablePartial;

		return (
			<div className="service-item-container position-col-reset">
				<div>
					<table>
						<tbody>
							<tr>
								<td className="align-middle service-icon">
									<img src={service.Icon} alt={service.Title} />
								</td>
								<td className="align-middle service-title" onClick={this.onClickItem}>
									<span>{service.Title}</span>
								</td>
								<td className="align-middle service-flag">
									{
										this.props.showAvailability && (!service.IsAvailable || showWarning) &&
										<SkodaTooltip id={'serviceItemTooltip_' + service.Code} effect={"solid"} type={"dark"} customTooltipContent={(parentKey) => this.getTooltipContent(parentKey)}>
											<span className="icon icon-status-warning-error"></span>
										</SkodaTooltip>
									}
									{
										this.props.showAvailability && !(!service.IsAvailable || showWarning) &&
										<span className="icon icon-check"></span>
									}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		);
	}
}